import { createSlice } from "@reduxjs/toolkit";
const jewellerySlice = createSlice({
  name: "jewellery",
  initialState: {
    loading: false,
    jewellery: null,
    jewelleryData: [],
    total: 0,
    page: 1,
    limit: 10,
    message: null,
    error: null,
    jewelleryOrders: [],
    ordersTotal: 0,
    ordersPage: 1,
    ordersLimit: 10,
  },
  reducers: {
    // ---- list ----
    getJewelleryRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getJewellerySuccess: (state, action) => {
      state.loading = false;
      state.jewelleryData = action?.payload?.data?.data || [];
      state.total = action?.payload?.data?.total || 0;
      state.page = action?.payload?.data?.page || 1;
      state.limit = action?.payload?.data?.limit || 10;
    },
    getJewelleryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // ---- create ----
    saveJewelleryRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    saveJewellerySuccess: (state, action) => {
      state.loading = false;
      state.jewellery = action.payload?.data;
      state.message = action.payload?.message;
    },
    saveJewelleryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // ---- edit ----
    editJewelleryRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    editJewellerySuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;

      const updated = action.payload?.data;
      state.jewelleryData = state.jewelleryData.map((item) =>
        item._id === updated._id ? updated : item,
      );
    },
    editJewelleryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // ---- change status ----
    changeJewelleryStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    changeJewelleryStatusSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;

      const updated = action.payload?.data;
      state.jewelleryData = state.jewelleryData.map((item) =>
        item._id === updated._id ? { ...item, enabled: updated.enabled } : item,
      );
    },
    changeJewelleryStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // ---- delete ----
    deleteJewelleryRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteJewellerySuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;

      const deletedId = action.payload?.data?._id;
      state.jewelleryData = state.jewelleryData.filter(
        (item) => item._id !== deletedId,
      );
      state.total = Math.max(state.total - 1, 0);
    },
    deleteJewelleryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addJewelleryInventoryRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    addJewelleryInventorySuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    addJewelleryInventoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    //---- toggle inventory status ----
    toggleJewelleryInventoryRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    toggleJewelleryInventorySuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    toggleJewelleryInventoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // ---- edit inventory ----
    editJewelleryInventoryRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.message = null;
    },
    editJewelleryInventorySuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    editJewelleryInventoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    clearJewelleryMessage: (state) => {
      state.message = null;
      state.error = null;
    },

    getJewelleryOrdersRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getJewelleryOrdersSuccess: (state, action) => {
      state.loading = false;
      state.jewelleryOrders = action?.payload?.data?.data || [];
      state.ordersTotal = action?.payload?.data?.total || 0;
      state.ordersPage = action?.payload?.data?.page || 1;
      state.ordersLimit = action?.payload?.data?.limit || 10;
    },
    getJewelleryOrdersFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    changeJewelleryOrderStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    changeJewelleryOrderStatusSuccess: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    changeJewelleryOrderStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getJewelleryRequest,
  getJewellerySuccess,
  getJewelleryFailure,
  saveJewelleryRequest,
  saveJewellerySuccess,
  saveJewelleryFailure,
  editJewelleryRequest,
  editJewellerySuccess,
  editJewelleryFailure,
  changeJewelleryStatusRequest,
  changeJewelleryStatusSuccess,
  changeJewelleryStatusFailure,
  deleteJewelleryRequest,
  deleteJewellerySuccess,
  deleteJewelleryFailure,
  clearJewelleryMessage,
  addJewelleryInventoryRequest,
  addJewelleryInventorySuccess,
  addJewelleryInventoryFailure,
  getJewelleryOrdersRequest,
  getJewelleryOrdersSuccess,
  getJewelleryOrdersFailure,
  changeJewelleryOrderStatusRequest,
  changeJewelleryOrderStatusSuccess,
  changeJewelleryOrderStatusFailure,
  toggleJewelleryInventoryRequest,
  toggleJewelleryInventorySuccess,
  toggleJewelleryInventoryFailure,
  editJewelleryInventoryRequest,
  editJewelleryInventorySuccess,
  editJewelleryInventoryFailure,
} = jewellerySlice.actions;

export default jewellerySlice.reducer;
